import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { ShippingPage, shippingZonesQueryOptions } from '@/features/shipping';

export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/shipping')({
  staticData: { crumb: 'common:nav.shipping', tours: ['settings.shipping'] },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'settings.read');
  },
  loader: ({ context, params }) =>
    context.queryClient
      .query({ ...shippingZonesQueryOptions(params.storeId), staleTime: 'static' })
      .catch(() => undefined),
  component: ShippingPage,
});
